import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { getAllCorrBankAction } from "../action/getAllCorrBankAction";

const initialState: CreateAppData = {
  data: [],
  loading: false,
  error: null,
};

const getAllCorrBankSlice = createSlice({
  name: "getAllCorrBankSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCorrBankAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCorrBankAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.result.result;
      })
      .addCase(getAllCorrBankAction.rejected, (state, action) => {
        state.loading = false;
        //state.error = action.payload;
      });
  },
});

export const getAllCorrBankReducer = getAllCorrBankSlice.reducer;
